import { Component, Input, OnInit, Output, SimpleChanges, /* SimpleChange, */ OnChanges, EventEmitter, forwardRef} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

/**
   * Logger Factory
   * @namespace icon: name of icon to show
   * @namespace chnage: emit the current value of input 
   * @namespace name: title of label
   * @namespace type: is the type of input (text, number, password)
   * @namespace errorMessage: message to show in error case
   * @namespace adviseMessage: advise message 
   * @namespace minLength: min length of value of input value
   * @namespace maxLength: max length of value of input value
   * @namespace change: is the output that take off tio the parent the current value
   * ES:
   *  <ute-input type="password" 
   *             errorMessage="Deve contenere almeno 8 caratterei" name="title" 
   *              formControlName="title"   
   *              [(ngModel)]="title" 
   *              (change)="test($event)">
   *   </ute-input>
*/

@Component({
  selector: 'ute-input',
  templateUrl: 'ute-input.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UteInputComponent),
    multi: true
  }]
})
export class UteInputComponent  implements  OnInit, OnChanges, ControlValueAccessor {
  @Input() icon: string;
  @Input() title: string;
  @Input() label: string;
  @Input() type: string;
  @Input() style: string;
  @Input() pattern: string;
  @Input() errorMessage: string;
  @Input() adviseMessage: string;
  @Input() wrongPassword: string;

  @Input() wrongPasswordCondition: boolean;

  @Input() maxlength: string;
  @Input() minlength: string;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();

  public showPassword: boolean = false;
  public idInput: string;
  public value: string = '';
  private propagateChange = (_: any) => { };
  private propagateTouch = () => { };

  constructor() {
  }

  ngOnInit() {
    this.idInput = `input-${this.title}`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.title) {
      this.idInput = `input-${changes.title.currentValue}`;
    }
    if(changes.type && changes.type.currentValue === 'password'){
      this.icon = 'show';
    }
  }

  onChange(event) {
    this.value = event.target.value;
    this.propagateChange(event.target.value);
    this.change.emit(event);
  }

 
  ionViewDidLoad(){
  }

  onBlur(event) {
    this.propagateTouch();
    this.blur.emit(event);
  }

  public writeValue(obj: any) {
    if(obj) this.value = obj;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }

  togglePassword(){
    if(this.type === 'password'){
      this.showPassword = !this.showPassword;
      if(this.showPassword){
        this.icon = 'hide';
      }else{
        this.icon = 'show';
      }
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/components/commons/atoms/ute-input/ute-input.component.ts